module.exports = __webpack_public_path__ + "static/media/check-circle-regular.38c778b5.svg";